// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"14f1bbfd","450":"48ece00c","495":"3b1e29da","538":"efbc22da","924":"3e3d99e4"}[chunkId] + ".chunk.css";
};